import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
// ========================== 工具函数：动态生成「当前月前6个月」选项 ==========================
const generateRecent6Months = () => {
    const dateOptions = [];
    const currentDate = new Date();
    for (let i = 0; i < 6; i++) {
        const targetDate = new Date(currentDate);
        targetDate.setMonth(currentDate.getMonth() - i);
        const year = targetDate.getFullYear();
        const month = String(targetDate.getMonth() + 1).padStart(2, "0");
        const dateStr = `${year}-${month}`;
        dateOptions.push({ key: dateStr, label: dateStr });
    }
    return dateOptions;
};
// ========================== 工具函数：生成Menu菜单项 ==========================
const getMenuItems = (dateOptions, onSelect) => {
    return dateOptions.map((option) => ({
        key: option.key,
        label: option.label,
        style: {
            color: "#fff",
            padding: "0.05rem 0.15rem",
            margin: 0,
        },
        selectedStyle: {
            backgroundColor: "rgba(16, 153, 251, 0.2)",
            color: "#1099fb",
        },
        onClick: () => onSelect(option.key),
    }));
};
// ========================== 核心组件（修复Dropdown警告） ==========================
const DateDropdown = ({ initDate, onDateChange, btnClassName = "", }) => {
    const [selectedDate, setSelectedDate] = useState(initDate);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dateOptions = generateRecent6Months();
    const handleDateSelect = (date) => {
        setSelectedDate(date);
        onDateChange(date);
        setIsDropdownOpen(false);
    };
    // 生成菜单配置（替代原renderMenu函数）
    const menuConfig = {
        items: getMenuItems(dateOptions, handleDateSelect),
        className: "bg-slate-800/90 backdrop-blur-sm border border-blue-500/20 rounded-md",
        style: {
            fontSize: "0.13rem",
            padding: "0.05rem 0",
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            border: "1px solid #446b9f",
            borderRadius: "6px",
        },
    };
    useEffect(() => {
        setSelectedDate(initDate);
    }, [initDate]);
    return (_jsx(Dropdown, { menu: menuConfig, placement: "bottomRight", open: isDropdownOpen, onOpenChange: setIsDropdownOpen, trigger: ["click"], children: _jsxs("button", { className: `
          flex items-center 
          text-white hover:text-blue-200 
          bg-blue-900/20 hover:bg-blue-800/30 
          px-[0.1rem] py-[0.05rem] 
          rounded-md border border-transparent hover:border-blue-400/50 
          transition-all duration-200
          ${btnClassName}
        `, onClick: (e) => e.preventDefault(), children: [_jsx("span", { className: "text-[0.14rem] mr-[0.05rem] font-medium", children: selectedDate }), _jsx(DownOutlined, { className: `text-[0.12rem] transition-transform duration-200 ${isDropdownOpen ? "rotate-180" : ""}` })] }) }));
};
export default DateDropdown;
